import posthog from "posthog-js";

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";

if (POSTHOG_KEY) {
    posthog.init(POSTHOG_KEY, {
        api_host: "/ingest",
        ui_host: POSTHOG_HOST.replace(".i.posthog.com", ".posthog.com"),
        defaults: "2026-08-30",
    });
}
